import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';
import { MonitoreoService } from '../service/monitoreo/MonitoreoService';
import { useToken } from '../components/useToken';


const AlertasContext = createContext();

export const AlertasProvider = ({ children }) => {
    const [totalAlertas, setTotalAlertas] = useState(0);
    const [loading, setLoading] = useState(false);
    const { getValorClave } = useToken();
    const puedeVerAlertas = getValorClave('verAlerta');
    const monitoreoService = useMemo(() => new MonitoreoService(), []);

    const refrescarAlertas = useCallback(() => {
        if (!puedeVerAlertas) return;
        setLoading(true);
        return monitoreoService.consultarInfo('configuracion-alerta/contar-alertas').then(res => {
            setTotalAlertas(res.data || 0);
        }).catch((error) => {
            setTotalAlertas(0);
        }).finally(() => {
            setLoading(false);
        });
    }, [monitoreoService, puedeVerAlertas]);

    // Efecto para el ciclo de vida (carga inicial + intervalo)
    useEffect(() => {
        const TIEMPO_REFRESCO = 30 * 60 * 1000;

        // Carga inicial
        refrescarAlertas();

        // Intervalo automático
        const intervalId = setInterval(refrescarAlertas, TIEMPO_REFRESCO);

        // Limpieza
        return () => clearInterval(intervalId);
    }, [refrescarAlertas]);

    // Valores que exportamos al resto de la app
    const contextValue = { totalAlertas, loading, refrescarAlertas };

    return (
        <AlertasContext.Provider value={contextValue}>
            {children}
        </AlertasContext.Provider>
    );
};

// Custom hook
export const useAlertas = () => {
    const context = useContext(AlertasContext);
    if (!context) {
        throw new Error("useAlertas debe ser usado dentro de un AlertasProvider");
    }
    return context;
};